module.exports = __webpack_public_path__ + "img/NIST-mmg.d282e991.png";